import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import intl from './intl'


class IntlProvider extends PureComponent {

  static childContextTypes = {
    intlData: PropTypes.shape({
      locale: PropTypes.string.isRequired,
      intl: PropTypes.object.isRequired,
    }),
  }

  getChildContext() {
    const { locale } = this.props

    return {
      intlData: {
        locale,
        intl,
      },
    }
  }

  render() {
    const { children } = this.props

    return children
  }
}


export default IntlProvider
